<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "StrategyManage"
    }
</script>

<style scoped>

</style>
